import {RingBuffer} from "../util/RingBuffer";
import {useRef, useState} from "react";

export function useRingBuffer<T>(size: number): IRingBuffer<T> {
    const buffer = useRef(new RingBuffer<T>(size))
    const [bufferState, setBufferState] = useState<T[]>([])
    return {
        value: bufferState,
        size: buffer.current.getSize(),
        count: buffer.current.getBufferLength(),
        add: (...values: T[]) => {
            buffer.current.add(...values)
            setBufferState(buffer.current.toArray())
        },
        clear: () => {
            buffer.current.clear()
            setBufferState([])
        }
    }
}

export interface IRingBuffer<T> {
    value: T[]
    add: (...values: T[]) => void
    clear: () => void
    size: number
    count: number
}